// extracted by mini-css-extract-plugin
export default {"App":"OpenTabs_App__71GKA","open_tabs":"OpenTabs_open_tabs__pqQb2","tab":"OpenTabs_tab__VTzat","over":"OpenTabs_over__UKGQU","active":"OpenTabs_active__9eVcE"};